import React from "react";
import styles from "./TermsAndConditions.module.css";
import { ContactData } from "../../controller/ContactData";

const TermsAndConditions = () => {
  // Separate email and address from ContactData
  const email = ContactData.find((item) => item.id === 1)?.text;
  const phone = ContactData.find((item) => item.id === 2)?.text;
  const address = ContactData.find((item) => item.id === 3)?.text;
  const effectiveDate = "16/10/2025";

  const sections = [
    {
      title: "1.Ownership and Relationship",
      content: [
        "Holy Bharat is a digital initiative operated and maintained by Bharat Clouds Private Limited, a company incorporated under the laws of India, having its office at: Module 308, Second Floor, NSIC Software Technology Business Park, Sector B-24, Guindy Industrial Estate, Ekkattuthangal, Chennai, Tamil Nadu – 600032. ",
        "All rights, title, and interest in the Platform, including its design, content, and features, remain the exclusive property of Bharat Clouds Private Limited.",
      ],
    },
    {
      title: "2. Eligibility",
      content: [
        "The Holy Bharat platform isn’t meant for use by children. We don’t collect their personal information, and if any such data is found, it will be promptly deleted.",
      ],
    },
    {
      title: "3.  Use of the Platform",
      content: [
        "You agree to use the Platform only for lawful purposes and in compliance with these Terms.",
        "Users may:",
      ],
      list: [
        "View temple-related information and content made available on the Platform. ",
        "Register and contribute temple details, including descriptions, images, and other related data. ",
      ],
      content2: ["Users shall not:"],
      list2: [
        "Submit false, misleading, or unauthorized content.",
        "Engage in any activity that disrupts or interferes with Platform operations.",
        "Attempt to access data, systems, or accounts without authorization.",
        "Upload content that violates intellectual property or privacy rights.",
        "Use the Platform for commercial solicitation or spam.",
      ],
    },
    {
      title: "4. User Accounts and Authentication",
      content: [
        "To access certain features, users must create an account or log in using social authentication providers (such as Facebook, LinkedIn, or Google).",
        "You are responsible for maintaining the confidentiality of your login credentials and any activity under your account. If unauthorized access or suspicious activity occurs, you must promptly notify info@bharatclouds.com.",
        "We reserve the right to suspend or terminate accounts found in violation of these Terms.",
      ],
    },
    {
      title: "5. User Content and Submissions",
      content: [
        "Users may contribute temple-related data including descriptions, images, and other informational content (“User Content”).",
        "By submitting User Content, you:",
      ],
      list: [
        "Grant Bharat Clouds Private Limited is a non-exclusive, royalty-free, perpetual, and worldwide license to use, display, and distribute the content on the Platform.",
        "Confirm that the content is accurate, lawful, and does not infringe upon third-party rights.",
        "Acknowledge that the submitted information may be publicly visible on the Platform.",
      ],
      content2: [
        "The Company reserves the right to review, edit, or remove any content that violates these Terms or applicable laws.",
      ],
    },
    {
      title: "6. Data Collection and Privacy",
      content: [
        "Your use of the Platform is also governed by our Privacy Policy, which details how we collect, use, and protect user information. By using the Platform, you consent to such collection and processing in accordance with the Privacy Policy. ",
        "User information may include registration data, authentication details, device information, and temple submissions necessary to operate the Platform effectively. ",
      ],
    },
    {
      title: "7. Intellectual Property Rights ",
      content: [
        "All intellectual property rights in the Platform, including text, graphics, images, software, and other content, belong to Bharat Clouds Private Limited or its licensors.",
        "You may not copy, modify, reproduce, or distribute any part of the Platform’s content without prior written consent from the Company.",
        "User-generated content remains the intellectual property of the user; however, by submitting such content, the user grants Bharat Clouds Private Limited a non-exclusive, royalty-free license to use, display, and distribute the content on the Platform as outlined in Section 6.",
      ],
    },
    {
      title: "8. Third-Party Services and Links",
      content: ["The Platform integrates third-party services such as:"],
      list: [
        "Google Maps (for temple locations),",
        "Facebook, LinkedIn, and Google (for authentication), and",
        "Analytics and hosting providers.",
      ],
      content2: [
        "The Company is not responsible for the content, privacy practices, or terms of these third-party platforms. ",
        "Users are encouraged to review their respective privacy and terms of documents before interacting.",
      ],
    },
    {
      title: "9. Disclaimers",
      content: [
        "The Platform and all content are provided “as is” and “as available” without warranties of any kind, express or implied.",
        "We do not guarantee: ",
      ],
      list: [
        "Accuracy, reliability, or completeness of information;",
        "Continuous availability or uninterrupted operation;",
        "Error-free functionality or protection against malware or unauthorized access.",
      ],
      content2: ["Use of the Platform is at the user’s sole risk. "],
    },
    {
      title: "10. Limitation of Liability",
      content: [
        "To the maximum extent permitted by law, Bharat Clouds Private Limited shall not be liable for any direct, indirect, incidental, or consequential damages arising from:",
      ],
      list: [
        "Use or inability to use the Platform;",
        "Data loss, unauthorized access, or service interruption;",
        "Errors, omissions, or inaccuracies in content.",
      ],
      content2: [
        "Users acknowledge that the Company’s liability is strictly limited as permitted under applicable Indian law. ",
      ],
    },
    {
      title: "11. Suspension and Termination ",
      content: [
        "We reserve the right to suspend or terminate access to the Platform at any time if: ",
      ],
      list: [
        "A user violates these Terms or applicable laws;",
        "Unauthorized or suspicious activity is detected; or",
        "Required for maintenance, legal compliance, or security reasons.",
      ],
      content2: [
        "Upon termination, all rights granted under these Terms shall cease immediately. ",
      ],
    },
    {
      title: "12. Indemnification",
      content: [
        "You agree to indemnify and hold harmless Bharat Clouds Private Limited, its affiliates, employees, and partners from any claims, damages, or liabilities arising from:",
      ],
      list: [
        "Your use of the Platform;",
        "Your submitted content;",
        "Your breach of these Terms or any applicable law.",
      ],
    },
    {
      title: "13. Changes to Terms ",
      content: [
        "We may revise or update these Terms from time to time. All modifications will be effective upon posting on the Platform with an updated effective date. Continued use after such updates constitutes acceptance of the revised Terms. ",
      ],
    },
    {
      title: "14. Governing Law and Jurisdiction",
      content: [
        "These Terms shall be governed by and construed in accordance with the laws of India. All disputes arising from or relating to the Platform shall be subject to the exclusive jurisdiction of the competent courts in Chennai, Tamil Nadu. ",
      ],
    },
    {
      title: "15. Contact Information",
      content: [
        "For questions or clarifications regarding these Terms, please contact us at: ",
      ],
    },
  ];

  return (
    <div className={`mb-4 ${styles.termsContainer}`}>
      {/* Heading */}
      <div className={styles.headingContainer}>
        <h2 className={`main_heading ${styles.mainHeading}`}>
          Terms and Conditions
        </h2>
      </div>
      <div className={styles.effectiveDetails}>
        <div>
          <strong>Effective Date:</strong> {effectiveDate}
        </div>
        <div>
          <strong>Entity:</strong> Bharat Clouds Private Limited
        </div>
        <div>
          <strong>Product:</strong> Holy Bharat
        </div>
      </div>
      <div className={styles.titleWrapper}>
        <h2 className={`${styles.titleHeading}`}>
          Welcome to Holy Bharat, a product of Bharat Clouds Private Limited
          (“Company,” “we,” “our,” or “us”). These Terms and Conditions
          (“Terms”) govern your access to and use of the Holy Bharat website,
          mobile application, and related services (collectively, the
          “Platform”).
        </h2>
      </div>
      <div className={styles.titleWrapper}>
        <h2 className={`${styles.titleHeading}`}>
          By accessing or using the Platform, you agree to comply with and be
          bound by these Terms and our Privacy Policy. If you do not agree,
          please refrain from using the Platform.
        </h2>
      </div>
      <div className={styles.titleWrapper}>
        <h2 className={`${styles.titleHeading}`}>
          We may modify or update these Terms at any time, and such changes will
          be posted on the Platform with a revised effective date. Continued use
          of the Platform constitutes acceptance of the updated Terms.
        </h2>
      </div>
      {/* Sections */}
      {sections.map((section, index) => (
        <div key={index} className={styles.policySection}>
          <h3>{section.title}</h3>

          {section.content.map((para, i) => (
            <p key={i}>{para}</p>
          ))}

          {section.list && (
            <ul>
              {section.list.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          )}

          {/* Secondary content */}
          {section.content2?.map((para, i) => (
            <p key={`content2-${i}`}>{para}</p>
          ))}

          {/* Secondary list */}
          {section.list2 && (
            <ul>
              {section.list2.map((item, i) => (
                <li key={`list2-${i}`}>{item}</li>
              ))}
            </ul>
          )}
        </div>
      ))}
      <div className={styles.contactSection}>
        <h3 className={styles.policySectionH3}>Email:</h3>
        <p className={`py-2 ${styles.policySectionP}`}>{email}</p>

        <h3 className={styles.policySectionH3}>Phone:</h3>
        <p className={`py-2 ${styles.policySectionP}`}>{phone}</p>

        <h3 className={styles.policySectionH3}>Address:</h3>
         <p className={`py-2 ${styles.policySectionP}`}>{address}</p>
      </div>
    </div>
  );
};

export default TermsAndConditions;
